import { withDerived } from './transactionMath';

// Match the table's business net: card fees affect NET(U), not NET PROFIT.
export function summarizeAnalytics(rows) {
  const totals = rows.reduce((acc, row) => {
    const d = withDerived(row);
    acc.revenue += d.totalProfit;
    acc.spent += d.spentAll;
    acc.pending += d.spentIo1Pending;
    acc.pendingFees += d.spentIo15Pending;
    return acc;
  }, { revenue: 0, spent: 0, pending: 0, pendingFees: 0 });
  totals.projectedSpent = totals.spent + totals.pending;
  totals.net = totals.revenue - totals.spent;
  totals.projectedNet = totals.revenue - totals.projectedSpent;
  totals.roi = totals.spent > 0 ? totals.net / totals.spent * 100 : 0;
  totals.projectedRoi = totals.projectedSpent > 0 ? totals.projectedNet / totals.projectedSpent * 100 : 0;
  return totals;
}

export function analyticsByDate(rows) {
  const groups = new Map();
  rows.forEach(row => {
    const date = row.date.slice(0, 10);
    if (!groups.has(date)) groups.set(date, []);
    groups.get(date).push(row);
  });
  return [...groups].sort(([a], [b]) => a.localeCompare(b))
    .map(([date, records]) => ({ date, ...summarizeAnalytics(records) }));
}
